import { useEffect, useState } from "react";
import { media } from "../lib/api";
import { X } from "lucide-react";

export default function GalleryPage() {
  const [items, setItems] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => { media.list("gallery").then(setItems).catch(() => {}); }, []);

  return (
    <main data-testid="gallery-page" className="pt-28 min-h-screen pb-24 bg-white">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16 pt-12 mb-12">
        <span className="eyebrow">— Gallery</span>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl mt-4 text-ink">Inside <span className="text-gold">Onyx</span>.</h1>
        <p className="text-muted max-w-xl mt-4">A look inside Washington's most exclusive rooftop — peak nights, signature moments, and the energy that defines Onyx.</p>
      </div>

      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-3">
          {items.map((m, i) => (
            <button
              key={m.id}
              type="button"
              data-testid={`gallery-tile-${i}`}
              onClick={() => setLightbox(m)}
              className="group relative aspect-[4/5] overflow-hidden bg-cream block focus:outline-none"
            >
              <img
                src={m.url}
                alt={m.caption || "Onyx"}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300" />
              {m.caption && (
                <div className="absolute inset-x-0 bottom-0 p-3 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition duration-300">
                  <p className="text-white text-[11px] tracking-luxe-tight uppercase truncate">{m.caption}</p>
                </div>
              )}
            </button>
          ))}
        </div>
      </div>

      {lightbox && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 md:p-10"
          onClick={() => setLightbox(null)}
        >
          <button
            data-testid="lightbox-close"
            onClick={() => setLightbox(null)}
            className="absolute top-5 right-5 w-11 h-11 border border-white/30 text-white/80 hover:text-white hover:border-white flex items-center justify-center transition"
            aria-label="Close"
          >
            <X size={20} />
          </button>
          <img
            src={lightbox.url}
            alt={lightbox.caption || ""}
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          {lightbox.caption && (
            <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/70 text-[11px] tracking-luxe uppercase">{lightbox.caption}</p>
          )}
        </div>
      )}
    </main>
  );
}
